<div class="qaroni-duration-input flex w-full flex-col gap-1">
  <span class="text-xs text-neutral-50">{{ label() }}*</span>

  <div class="flex items-start gap-3" [formGroup]="form">
    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="qaroni-duration-input__field min-w-0 flex-1">
      <input
        matInput
        type="number"
        formControlName="hours"
        min="0"
        [max]="maxHours"
        (blur)="onBlur()" />
      <span matTextSuffix class="text-neutral-50">h</span>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="qaroni-duration-input__field min-w-0 flex-1">
      <input
        matInput
        type="number"
        formControlName="minutes"
        min="0"
        max="59"
        step="5"
        (blur)="onBlur()" />
      <span matTextSuffix class="text-neutral-50">min</span>
    </mat-form-field>
  </div>

  <div class="text-xs">
    <ng-content />
  </div>
</div>
